import { getIcons } from "_helpers";
import { useEffect, useState } from "react";
import { AlertsSidePanelTableViariables } from "views/portal/alerts";
import { SidePanelCard } from "_components/cards/SidePanelCard";
import { useSelector } from "react-redux";

export { AlertSidePanel };

/**
 * Contenu de la div lattérale pour la page alertes
 * @returns 
 */
function AlertSidePanel() {

    const { data } = useSelector((state) => state.sidePanel);

    const [classColor, setClassColor] = useState();
    const [urgencyLabel, setUrgencyLabel] = useState();
    const [evtDate, setEvtDate] = useState('');

    useEffect(() => {
        if(data) {
            if (data.URGENCY_LEVEL) {
                switch (data.URGENCY_LEVEL) {
                    case ("3"):
                        setUrgencyLabel('Alerte 3');
                        setClassColor('orange');
                        break;
                    case ("4"):
                        setUrgencyLabel('Stop 4');
                        setClassColor('red');
                        break;
                    case (""):
                        setUrgencyLabel('Pré-Alerte');
                        setClassColor('blue');
                        break;
                    default:
                        setUrgencyLabel(`Niveau ${data.URGENCY_LEVEL}`);
                        setClassColor('black');
                        break;
                }
            }

            if (data.HEADER_EVTDATE){
                // construction de la date au bon format
                const [datePart, timePart] = data.HEADER_EVTDATE.split(' ');
                const [hours, minutes] = timePart.split(':');
                const formattedDate = `${datePart} à ${hours}:${minutes}`;

                setEvtDate(formattedDate);
            }
        }    
    }, [data])


    return (
        <>
            {data && 
                <div>
                    <div className="side-panel-date">
                        <img src={getIcons('accessTimeOutlinedGrey')} alt='icone parametres' />
                        Créé le: {evtDate}
                    </div> 
                    <div className={`side-panel-title side-panel-title-${classColor}`}>
                        {urgencyLabel}
                    </div>              
                    <div className={`side-panel-title side-panel-title-${classColor}`}>
                        {data.HEADER_CODE} - {data.EVENT_DESC_FR}
                    </div>
                    <div className="side-panel-details">
                        <div className="side-panel-resume">
                            <div className="resume-title">{data.URGENCY_LEVEL === '' ? 'Pré-Alerte' : 'Alerte'}</div>
                            <div className="resume-description">{data.HEADER_TYPE}</div>
                            <div className="resume-title">HISTORIQUE</div>
                            <div className="resume-description">
                                <strong>{`${data?.NB_OCCURRENCE ?? 0}`}</strong> {` occurence${data?.NB_OCCURRENCE > 1 ? 's' : ''} `}
                                entre le <strong>{` ${new Date(data.FIRST_OCCURRENCE).toLocaleDateString()} ${new Date(data.FIRST_OCCURRENCE).toLocaleTimeString()} `}</strong> 
                                et le <strong>{` ${new Date(data.LAST_OCCURRENCE).toLocaleDateString()} ${new Date(data.LAST_OCCURRENCE).toLocaleTimeString()} `}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="my-4">
                        {<AlertsSidePanelTableViariables />}
                    </div>
                    <SidePanelCard data={data}/>
                </div>
            }
        </>
    )
}
